import * as React from "react";
import {
  extensionScopeLabels,
  extensionTypeLabels,
  ZExtension,
} from "src/business/extensions/ZExtension";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { urlForDownload } from "src/common/upload/urlForDownload";
import { BlankLink } from "src/components/BlankLink/BlankLink";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

export const createExtensionColumns = (): RtColumn<ZExtension>[] => [
  columnDisplayId,
  {
    key: "name",
    title: "Название",
    render: ({ name }) => name,
    minWidth: 200,
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description ?? "",
    minWidth: 220,
  },
  {
    key: "type",
    title: "Тип",
    render: ({ type }) => extensionTypeLabels[type],
    minWidth: 180,
  },
  {
    key: "file",
    title: "Файл расширения",
    render: ({ file }) =>
      file?.id ? (
        <BlankLink
          href={urlForDownload(file.id, false)}
          title={file.name}
          download={file.name}
        >
          {file.name}
        </BlankLink>
      ) : (
        ""
      ),
    minWidth: 220,
  },
  {
    key: "scope",
    title: "Область применения",
    render: ({ scope }) => (scope ? extensionScopeLabels[scope] : ""),
    minWidth: 200,
  },
  {
    key: "version",
    title: "Версия",
    render: ({ version }) => version ?? "",
    minWidth: 160,
  },
  ...sysColumnsHistory,
];
